import React from 'react';
import { LogoImage } from '../ui/LogoImage';
import EarlyAdopterBadge from '../ui/EarlyAdopterBadge';
import { TutorialTest } from '../tutorial/TutorialTest';

interface HeaderProps {
  onSignOut: () => void;
}

export function Header({ onSignOut }: HeaderProps) {
  return (
    <header className="bg-paper-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 md:h-16">
          {/* Left section - Early Adopter Badge + Dev tester (dev only) */}
          <div className="flex-1 flex items-center gap-2">
            <EarlyAdopterBadge variant="compact" className="ml-2" />
            {(process.env.NODE_ENV === 'development' || process.env.REACT_APP_SHOW_TUTORIAL_TEST === 'true') && (
              <div className="ml-2">
                <TutorialTest variant="inline" />
              </div>
            )}
          </div>
          
          {/* Center section - Brand */}
          <div className="flex flex-col items-center flex-1">
            <LogoImage size="md" showText={true} />
            {/* Uncomment the line below if you want to keep "Meal Archive" */}
            {/* <span className="text-xs md:text-sm text-text-medium font-medium tracking-wide uppercase">
              Meal Archive
            </span> */}
          </div>
          
          {/* Right section - Actions */}
          <div className="flex items-center space-x-2 md:space-x-3 flex-1 justify-end">
            <button
              onClick={onSignOut}
              className="neon-button compact md:text-xs md:px-1.5 md:py-1 md:h-8 whitespace-nowrap"
              aria-label="Sign out of application"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
} 